import { render } from "./index.vue?vue&type=template&id=1912cd17&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1912cd17&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=1912cd17&lang=css"
script.render = render
script.__scopeId = "data-v-1912cd17"

export default script